// extracted by mini-css-extract-plugin
export default {"textTooltipWrapper":"style_textTooltipWrapper__znZa7","topTip":"style_topTip__+66Dg","textTooltip":"style_textTooltip__E9uR0","content":"style_content__ZNupc"};